// Product page: gallery counter, zoom, options, add to cart, story "more", phone sticky bar,
// related products. No libraries. Without JS the form still posts to /cart/add and every
// detail is readable.
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  if (!$('.pdp')) return;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Gallery: "2 / 6" under the swipe strip, kept in step with whichever photo is showing
  const strip = $('.pdp__strip'), counter = $('.pdp__counter'), slides = $$('.pdp__slide');
  if (counter && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) counter.textContent = `${slides.indexOf(e.target) + 1} / ${slides.length}`;
    }), { root: strip, threshold: 0.6 });
    slides.forEach(s => io.observe(s));
  }

  // Zoom: full screen on white, drawn x or Escape to close, focus goes back to the photo
  const box = $('.pdp__lightbox');
  let opener;
  $$('.pdp__zoom').forEach(b => b.addEventListener('click', () => {
    const img = $('img', b), big = $('img', box);
    opener = b;
    big.src = b.dataset.zoom || img.currentSrc || img.src;
    big.alt = img.alt;
    box.showModal();
  }));
  box?.addEventListener('close', () => opener?.focus());
  $('.pdp__close')?.addEventListener('click', () => box.close());

  // Options. One option: the radios are the variant ids themselves. Two or more (colour + size):
  // the picked words are matched to a variant and its id goes in the hidden input.
  const form = $('.pdp__form'), buy = form && $('.pdp__buy', form), sold = $('.pdp__soldout');
  const notify = $('.notify__open');
  const live = $('.pdp__live'), err = $('.pdp__error'), bar = $('.pdp__bar');
  const data = $('#pdp-variants');
  const variants = data ? JSON.parse(data.textContent) : [];
  const groups = $$('.pdp__options');
  let barSeen = true, keyboard = false;

  const updateBar = () => { if (bar) bar.hidden = barSeen || keyboard || !buy || buy.hidden; };

  const pick = v => {
    if (!v) return;
    if (err) err.hidden = true;
    $$('.pdp__price-amount').forEach(p => (p.textContent = v.price));
    if (buy) buy.hidden = !v.available;
    if (sold) sold.hidden = v.available;
    if (notify) notify.hidden = v.available;
    const hidden = form && $('input[type=hidden][name=id]', form);
    if (hidden) hidden.value = v.id;
    const url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url);
    if (v.image) $('.pdp__slide img').src = v.image;
    updateBar();
  };

  document.addEventListener('change', e => {
    const t = e.target;
    if (!form || t.form !== form) return;
    if (t.name === 'id') return pick(variants.find(v => String(v.id) === t.value));
    if (t.dataset.optionIndex === undefined) return;
    const chosen = groups.map(g => $('input:checked', g)?.value);
    if (chosen.every(Boolean)) pick(variants.find(v => v.options.every((o, i) => o === chosen[i])));
  });

  // Add to cart: Ajax so the page stays put; the bag count updates and the pen "presses" once
  const say = t => { if (live) live.textContent = t; };
  const showErr = t => {
    if (err) {
      err.textContent = t;
      err.hidden = false;
    }
    say(t);
  };
  const label = form && $('.pdp__buy-label', form);
  const added = item => {
    say('added to cart');
    if (label) {
      // "added" with a drawn tick on its right; the pair stays centred in the box
      label.innerHTML = 'added<svg class="pdp__tick" aria-hidden="true" focusable="false"><use href="#drawn-check"/></svg>';
      setTimeout(() => (label.textContent = 'add to cart'), 1500);
    }
    const bag = $('.cart');
    if (bag && !calm) {
      bag.classList.remove('is-popping');
      void bag.offsetWidth;   // restart the pop if you add again mid-animation
      bag.classList.add('is-popping');
      bag.addEventListener('animationend', () => bag.classList.remove('is-popping'), { once: true });
    }
    // a cart drawer can listen for this later
    document.dispatchEvent(new CustomEvent('taku:cart-added', { detail: item }));
  };

  // Sold out: "notify me when available" opens a pop-up with name / email / optional phone. On Shopify
  // the form posts to the store's contact form and the page comes back with the pop-up saying thanks;
  // the preview just says thanks.
  const notifyBox = $('.notify-dialog');
  if (notify && notifyBox) {
    const fields = $('.notify__fields', notifyBox), done = $('.notify__done', notifyBox);
    notify.addEventListener('click', () => notifyBox.showModal());
    $('.notify-dialog__close', notifyBox).addEventListener('click', () => notifyBox.close());
    // a click on the greyed page around the card closes it too
    notifyBox.addEventListener('click', e => { if (e.target === notifyBox) notifyBox.close(); });
    notifyBox.addEventListener('close', () => notify.focus());
    if (notifyBox.dataset.open !== undefined) notifyBox.showModal();
    if (!window.Shopify) $('.notify__form', notifyBox).addEventListener('submit', e => {
      e.preventDefault();
      const first = (new FormData(e.target).get('contact[name]') || '').trim().split(/\s+/)[0].toLowerCase();
      fields.hidden = true;
      done.innerHTML = `thanks${first ? ', ' + first.replace(/[<>&"]/g, '') : ''}. we'll email you when it's available<svg class="pdp__tick" aria-hidden="true" focusable="false"><use href="#drawn-check"/></svg>`;
      done.hidden = false;
    });
  }

  form?.addEventListener('submit', async e => {
    e.preventDefault();
    if (!buy || buy.getAttribute('aria-busy') === 'true') return;
    if (err) err.hidden = true;
    // sized pieces start with nothing picked, so every option is always a choice
    const missing = groups.find(g => !$('input:checked', g));
    if (missing) {
      showErr(`pick a ${$('legend', missing).textContent.trim()}`);
      $('input', missing).focus();
      return;
    }
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity')) || 1;
    buy.setAttribute('aria-busy', 'true');
    buy.classList.add('is-pushed');   // the press also shows for Enter / the phone bar, not just a mouse :active
    setTimeout(() => buy.classList.remove('is-pushed'), 140);
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] })
      });
      if (r.ok) {
        const json = await r.json();
        await window.takuCart?.refresh();
        added(json.items?.[0] || { id, quantity });
      } else if (!window.Shopify) {
        // static preview (no Shopify cart here): the drawer keeps a stand-in cart in this tab
        await window.takuCart?.add(id, quantity);
        added({ id, quantity });
      } else {
        const json = await r.json().catch(() => ({}));
        throw new Error(json.description || 'couldn’t add that, try again');
      }
    } catch (x) {
      showErr(x.message.toLowerCase());
    } finally {
      buy.removeAttribute('aria-busy');
    }
  });

  // Story: CSS already shows three lines and "more" from the first paint (no jump after load);
  // here we only drop "more" when there's nothing hidden, and open/close it
  const story = $('.pdp__story-text'), more = $('.pdp__more');
  if (story && more) {
    if (story.scrollHeight <= story.clientHeight + 2) more.hidden = true;
    more.addEventListener('click', () => {
      const open = story.classList.toggle('is-open');
      more.textContent = open ? 'less' : 'more';
      more.setAttribute('aria-expanded', String(open));
    });
  }

  // Quantity: – 1 +. The minus only appears once you've gone above 1, and never goes below 1.
  const stepper = $('.garment__stepper');
  if (stepper) {
    const count = $('.garment__count', stepper), field = $('input[name=quantity]', stepper);
    const minus = $('.garment__step--minus', stepper), plus = $('.garment__step--plus', stepper);
    const MAX = 9;
    const set = n => {
      n = Math.min(MAX, Math.max(1, n));
      count.textContent = field.value = n;
      minus.disabled = n === 1;
      plus.disabled = n === MAX;
    };
    plus.addEventListener('click', () => set(Number(field.value) + 1));
    minus.addEventListener('click', () => {
      set(Number(field.value) - 1);
    });
  }

  // "size guide" next to the sizes opens that section and brings it into view
  $('.pdp__guide')?.addEventListener('click', () => {
    const d = $('#pdp-size-guide');
    if (!d) return;
    d.open = true;
    d.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    $('summary', d).focus({ preventScroll: true });
  });

  // Phone sticky bar: only after the big button has scrolled up out of view, never on sold out,
  // and out of the way while the keyboard is open
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      barSeen = e.isIntersecting || e.boundingClientRect.top > 0;
      updateBar();
    }).observe(buy);
    window.visualViewport?.addEventListener('resize', () => {
      keyboard = visualViewport.height < innerHeight * 0.75;
      updateBar();
    });
    $('.pdp__buy', bar).addEventListener('click', () => form.requestSubmit());
  }

  // Related: Shopify's own recommendations replace the same-collection fallback, if it has any
  const rec = $('[data-recommendations-url]');
  if (rec) {
    fetch(rec.dataset.recommendationsUrl)
      .then(r => (r.ok ? r.text() : ''))
      .then(t => {
        const fresh = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recommendations-url]');
        if (fresh?.querySelector('.product, .board')) rec.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  }
})();
